import {useCallback} from "react";

import {commonFiltersValue, encodeCommonFiltersShareValue} from "@signals";
import {DATE_PERIODS} from "@constants";

export default function useBannersPercentageLink(link) {
	const buildLink = useCallback(row => {
		const checkHaveRemainingData = key => !!row.remainingData && row.remainingData[0][key] != null

		const specificFilters = {
			...row.startDate && row.endDate && { startDate: row.startDate, endDate: row.endDate, currentPeriod: DATE_PERIODS.CUSTOM },
			...row.companyID != null && { company: [row.companyID] },
			...row.brandID != null && { brand: [row.brandID] },
			...(row.siteID != null || checkHaveRemainingData('siteID')) && { retailer: row.remainingData ? row.remainingData.map(({ siteID }) => siteID) : [row.siteID] },
			...(row.country || checkHaveRemainingData('country')) && { country: row.remainingData ? row.remainingData.map(({ country }) => country) : [row.country] },
			...(row.pageCategoryID != null || checkHaveRemainingData('pageCategoryID')) && { pageCategory: row.remainingData ? row.remainingData.map(({ pageCategoryID }) => pageCategoryID) : [row.pageCategoryID] },
			...(row.pageProductTypeID != null || checkHaveRemainingData('pageProductTypeID')) && { pageProductType: row.remainingData ? row.remainingData.map(({ pageProductTypeID }) => pageProductTypeID) : [row.pageProductTypeID] },
			...(row.imageTypeID != null || checkHaveRemainingData('imageTypeID')) && { resourceType: row.remainingData ? row.remainingData.map(({ imageTypeID }) => imageTypeID) : [row.imageTypeID] },
			...(row.tagID != null || checkHaveRemainingData('tagID'))  && { tags: row.remainingData ? row.remainingData.map(({ tagID }) => tagID) : [row.tagID] }
		}
		return `${link}?sp=${encodeCommonFiltersShareValue({...commonFiltersValue.value, ...specificFilters})}`
	}, [JSON.stringify(commonFiltersValue.value)])

	return {
		buildLink
	}
}